import { g as r } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as s, createElementBlock as d, normalizeClass as n, createElementVNode as e } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const f = {
  name: "DtIconDialpadAiColorReversed",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(l).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = r();
  }
}, p = ["aria-label", "data-qa", "aria-hidden"], c = ["clip-path"], m = ["fill"], h = ["id"], v = ["id"];
function _(a, t, o, g, I, i) {
  return s(), d("svg", {
    "aria-label": o.ariaLabel,
    class: n([i.iconSizeClass, "d-icon d-icon--dialpad-ai-color-reversed"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Dialpad Ai Color Reversed",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    e("g", {
      "clip-path": `url(#${a.uniqueID}a)`
    }, [
      e("path", {
        d: "M0 5.301A5.301 5.301 0 0 1 5.301 0h13.398A5.301 5.301 0 0 1 24 5.301v13.398A5.301 5.301 0 0 1 18.699 24H5.301A5.301 5.301 0 0 1 0 18.699V5.301Z",
        fill: `url(#${a.uniqueID}b)`
      }, null, 8, m),
      t[0] || (t[0] = e("path", {
        d: "M19.725 7.634c0 .693-.585 1.255-1.307 1.255s-1.307-.562-1.307-1.255c0-.693.585-1.255 1.307-1.255s1.307.562 1.307 1.255ZM8.856 9.142c.27-.88.787-1.166 1.088-1.166.301 0 .817.285 1.087 1.162v.001l1.964 6.332v.002c.417 1.35 1.503 2.626 3.071 2.626a3.41 3.41 0 0 0 3.41-3.41v-4.335a1.038 1.038 0 0 0-2.075 0v4.336c0 .737-.598 1.334-1.335 1.334-.3 0-.817-.286-1.087-1.163l-1.964-6.333C12.598 7.177 11.512 5.9 9.943 5.9c-1.57 0-2.657 1.28-3.072 2.632v.002l-2.55 8.22a1.038 1.038 0 0 0 1.982.615l2.551-8.226v-.001Z",
        fill: "#fff"
      }, null, -1))
    ], 8, c),
    e("defs", null, [
      e("linearGradient", {
        id: `${a.uniqueID}b`,
        x1: "25.431",
        y1: "23.998",
        x2: "10.959",
        y2: "-6.687",
        gradientUnits: "userSpaceOnUse"
      }, [...t[1] || (t[1] = [
        e("stop", {
          offset: ".297",
          "stop-color": "#7C52FF"
        }, null, -1),
        e("stop", {
          offset: ".762",
          "stop-color": "#F9008E"
        }, null, -1),
        e("stop", {
          offset: "1",
          "stop-color": "#F6AB3C"
        }, null, -1)
      ])], 8, h),
      e("clipPath", {
        id: `${a.uniqueID}a`
      }, [...t[2] || (t[2] = [
        e("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        }, null, -1)
      ])], 8, v)
    ])
  ], 10, p);
}
const D = /* @__PURE__ */ u(f, [["render", _]]);
export {
  D as default
};
//# sourceMappingURL=dialpad-ai-color-reversed.js.map
